import axios from 'axios';
import { storageGet } from './safeStorage';
const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
export const api = axios.create({
    baseURL: BASE.endsWith('/api/v1') ? BASE : `${BASE.replace(/\/$/, '')}/api/v1`,
    withCredentials: false,
});
api.interceptors.request.use((cfg) => {
    const token = storageGet('gestiora.token');
    if (token) {
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});
